import { AutoComplete, Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateManagePrescriptionSubmissionData } from "../../../actions/ManagePrescriptionAction";
import { AssetStore } from "../../../assets/AssetsStore";
import PrescriptionDropDown from "../../PrescriptionDropdown/PrescriptionDropDown";
import { PrescriprionContext } from "../../PrintPrescription/PrintPrescription";
import styles from "./index.module.scss";

function CovidDataPicker() {
  const dispatch = useDispatch();
  const submissionData = useSelector(
    (state) => state?.managePrescription?.submissionData
  );
  const { wholeData, handleWholeData } = useContext(PrescriprionContext);

  let reasons = ["Reason-1", "Reason-2", "Reasoon-3"];
  let [reasonOptions, setReasonOptions] = useState([]);

  // State to store vaccine names
  const [vaccineNames, setVaccineNames] = useState({});

  let handleDataChange = ({ key, value }) => {
    handleWholeData(key, value);
    dispatch(
      updateManagePrescriptionSubmissionData({
        [key]: value,
      })
    );
  };

  useEffect(() => {
    setReasonOptions([...convertToDropdownData(reasons)]);
  }, []);

  let onReasonChange = (e) => {
    let filteredValues = reasons.filter((item) =>
      item.toLowerCase().includes(e.toLowerCase())
    );
    filteredValues.map((each) => {
      each = { label: each, value: each };
    });

    if (e) {
      setReasonOptions([
        ...convertToDropdownData(filteredValues),
        { label: e, value: e },
      ]);
    } else {
      setReasonOptions([...convertToDropdownData(filteredValues)]);
    }
  };

  let onReasonSelect = (value) => {
    handleDataChange({ key: "nonVaccinationReason", value });
  };

  let convertToDropdownData = (data) => {
    let result = [];
    data.map((each) => {
      result.push({ label: each, value: each });
    });
    return result;
  };

  let getDoseCountAsNumber = () => {
    if (wholeData?.vaccinationDoseCount) {
      return [...Array(Number(wholeData?.vaccinationDoseCount))];
    } else {
      return [];
    }
  };

  let restrictDoseCountInput = (e) => {
    let { value } = e.target;
    if (
      (Number(value) <= 9 && Number(value) > 0 && value.match(/[0-9]/g)) ||
      value === ""
    ) {
      // Reset vaccine names if dose count is changed
      setVaccineNames({});
      handleDataChange({ key: "vaccinationDoseCount", value });
    }
  };

  let restrictOnKeyDown = (evt) => {
    console.log(evt.key);
    if (["-", "+", "e"].includes(evt.key)) {
      evt.preventDefault();
    }
  };
console.debug('vaccinationNames', vaccineNames)
  return (
    <div className={styles.container}>
      <div className={styles.status_dose_wrap}>
        <div className={styles.form_item}>
          <div className={styles.form_item_title}>Covid vaccination status</div>
          <div
            className={`${styles.form_item_content} ${styles.vaccination_status}`}
          >
            <PrescriptionDropDown
              className={styles.yes_no_select}
              value={wholeData?.vaccinationStatus ? wholeData?.vaccinationStatus : undefined }
              defaultPlaceH={"Select"}
              onChange={(value) => {
                handleDataChange({ key: "vaccinationStatus", value });
              }}
              DataItem={["Yes", "No"]}
            />
          </div>
        </div>

        {wholeData?.vaccinationStatus === "Yes" ? (
          <div className={styles.form_item}>
            <div className={styles.form_item_title}>Dose count <span style={{color:"red",fontSize: "larger"}}>*</span></div>
            <div className={styles.form_item_content}>
              <input
                onKeyDown={restrictOnKeyDown}
                onChange={restrictDoseCountInput}
                maxLength={1}
                type="number"
                placeholder="Type here"
                max={9}
                pattern={new RegExp("^[0-9,\b][0-9,\b]*$")}
                value={wholeData?.vaccinationDoseCount || ""}
                className={styles.form_item_dose_input}
              />
            </div>
          </div>
        ) : null}
      </div>

      {wholeData?.vaccinationStatus === "Yes" ? (
        <div className={styles.covid_yes_wrap}>
          <div className={styles.vaccines_wrap}>
            {getDoseCountAsNumber().map((elem, key) => {
              return (
                <div key={key} className={styles.form_item}>
                  <div className={styles.form_item_title}>
                    Name of vaccine dose - {key + 1}<span style={{color:"red", fontSize: "larger"}}>*</span>
                  </div>
                  <div className={styles.form_item_content}>
                    <PrescriptionDropDown
                      className={styles.vaccineName}
                      defaultPlaceH={"Select"}
                      value={wholeData[`vaccinationName${key + 1}`] || undefined}
                      
                      onChange={(value) => {
                        // Update vaccine names state
                        setVaccineNames(prevState => ({
                          ...prevState,
                          [key]: value
                        }));
                        handleDataChange({
                          key: `vaccinationName${key + 1}`,
                          value,
                        });
                      }}
                      DataItem={["Covishield", "Covaxin","Sputnik V","Corbevax","Covovax"]} 
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      // ) : wholeData?.vaccinationStatus === "No" ? (
      //   <>
      //     <div className={styles.form_item}>
      //       <div className={styles.form_item_title}>
      //         Reason for non vaccination
      //       </div>
      //       <div className={styles.form_item_content}>
      //         <div className={styles.autocomplete_wrap}>
      //           <Select
      //             showSearch
      //             suffixIcon={<img src={AssetStore.mui_select} alt="" />}
      //             value={wholeData?.nonVaccinationReason || undefined}
      //             className={styles.reason_box_container}
      //             getPopupContainer={(trigger) => trigger.parentNode}
      //             options={reasonOptions}
      //             style={{
      //               width: 438,
      //             }}
      //             onSelect={onReasonSelect}
      //             onSearch={onReasonChange}
      //             placeholder="Input here"
      //           />
      //         </div>
      //       </div>
      //     </div>
      //   </>
      ) : null}
    </div>
  );
}

export default CovidDataPicker;
